import React, { useState } from 'react';
import InboundOutboundPerformance from '../components/charts/InboundOutboundPerformance';
import PutawayPickingPerformance from '../components/charts/PutawayPickingPerformance';

const DashboardInboundOutbound = () => {
  const tabs = ['Order', 'Putaway/Picking'];

  const monthOptions = [...Array(12)].map((_, i) => {
    const date = new Date();
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    date.setMonth(date.getMonth() - i);

    const value = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}`;

    const label = date.toLocaleDateString('id-ID', {
      month: 'long',
      year: 'numeric',
    });

    return { value, label };
  });

  const [activeTab, setActiveTab] = useState('Order');
  const [selectedMonth, setSelectedMonth] = useState(monthOptions[0].value);

  return (
    <div className="p-1">
      {/* Tabs */}
      <div className="flex space-x-0 border-b mb-2">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 font-medium ${
              activeTab === tab
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-600'
            }`}
          >
            {tab.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
          </button>
        ))}
      </div>

      {/* Order Chart */}
      {activeTab === 'Order' && (
        <div className="bg-white p-4 shadow rounded">
          <InboundOutboundPerformance />
        </div>
      )}

      {/* Putaway/Picking Chart */}
      {activeTab === 'Putaway/Picking' && (
        <div className="bg-white p-4 shadow rounded">
          <PutawayPickingPerformance selectedMonth={selectedMonth} />
        </div>
      )}

      {/* Placeholder Tabs */}
      {['Lead_Time', 'Avg_Time'].includes(activeTab) && (
        <div className="bg-white p-4 shadow rounded">
          <h2 className="text-lg font-semibold">
            {activeTab.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
          </h2>
          <p className="text-gray-500">(coming soon)</p>
        </div>
      )}
    </div>
  );
};

export default DashboardInboundOutbound;
